import { useLocation, useNavigate } from 'react-router-dom'
import { useMe } from '../../api'
import { useSidebarPrefs, type DesktopPosition, type MobilePosition } from '../../lib/sidebarPrefs'
import { isActivePath, navItems } from '../nav/items'
import { Dock, type DockItemData, type Orientation } from './Dock'

// Tailwind utility groups for each anchor. Kept as full strings so the v4
// JIT picks them up — building class names by concatenation defeats it.
const desktopAnchor: Record<DesktopPosition, string> = {
  left: 'fixed top-1/2 left-3 -translate-y-1/2',
  right: 'fixed top-1/2 right-3 -translate-y-1/2',
  top: 'fixed top-3 left-1/2 -translate-x-1/2',
  bottom: 'fixed bottom-3 left-1/2 -translate-x-1/2',
}

const mobileAnchor: Record<MobilePosition, string> = {
  top: 'fixed top-3 left-1/2 -translate-x-1/2',
  bottom: 'fixed bottom-3 left-1/2 -translate-x-1/2',
}

function orientationFor(pos: DesktopPosition): Orientation {
  return pos === 'left' || pos === 'right' ? 'vertical' : 'horizontal'
}

export function DockSidebar() {
  const location = useLocation()
  const navigate = useNavigate()
  const { data: me } = useMe()
  const { prefs } = useSidebarPrefs(me?.id)
  const isAdmin = me?.role === 'admin'

  const items: DockItemData[] = navItems
    .filter(item => !item.adminOnly || isAdmin)
    .map(item => ({
      icon: item.icon,
      label: item.label,
      onClick: () => navigate(item.path),
      active: isActivePath(location.pathname, item.path),
    }))

  return (
    <>
      {/* Desktop: orientation depends on side. Hidden below md. */}
      <div className={`z-40 hidden md:block ${desktopAnchor[prefs.desktopPosition]}`}>
        <Dock items={items} orientation={orientationFor(prefs.desktopPosition)} />
      </div>
      {/* Mobile: always horizontal, top or bottom. */}
      <div className={`z-40 md:hidden ${mobileAnchor[prefs.mobilePosition]}`}>
        <Dock items={items} orientation="horizontal" />
      </div>
    </>
  )
}
